// External libraries
import { useApolloClient } from '@apollo/react-hooks';

//Internal modules
import { logger } from '@/lib';
import { getToken } from '@/lib/globals';
import { WPS_DONE_PAGE_QUERY } from '@/lib/graphql/queries';
import type {
  WpsDonePageQueryQuery,
  WpsDonePageQueryQueryVariables,
} from '@/generated/graphql';

export const useWPSDonePageQuery = ():
  | WpsDonePageQueryQuery
  | null
  | undefined => {
  const apolloClient = useApolloClient();
  try {
    return apolloClient.readQuery<
      WpsDonePageQueryQuery,
      WpsDonePageQueryQueryVariables
    >({
      query: WPS_DONE_PAGE_QUERY,
      variables: {
        token: getToken(),
      },
    });
  } catch (error) {
    if (error instanceof Error) {
      const { message, stack: stackTrace } = error;
      logger.warn('wps_apollo_client_read_query_error', {
        message,
        stackTrace,
      });
    }
  }
};
